import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SocketNotifications } from './socket-notifications.service';


@Injectable()
export class SocketService {
    constructor(private socketNotif: SocketNotifications) { }

    listenToChannel(channel: string): Observable<any> {
        return this.socketNotif.fromEvent(channel);
    }

    emitToChannel(channel: string, data: any) {
        this.socketNotif.emit(channel, data);
    }

    disconnect() {
        this.socketNotif.disconnect();
    }

    reconnect() {
        this.socketNotif.connect();
    }

    customSocketOn(event: string): Observable<any> {
        return new Observable((observer) => {
            this.socketNotif.on(event, (data: any) => {
                observer.next(data);
            });
            return () => this.socketNotif.off(event);
        });
    }
}
